/**
 * Filters out all falsy values from an array.
 * https://michaeluloth.com/javascript-filter-boolean/
 * @param {Array} arr - The array to filter.
 * @returns {Array} A new array with all falsy values removed.
 */
const removeFalsyItems = (arr) => arr.filter(Boolean);

export default removeFalsyItems;
